import React, { memo, useMemo } from "react";
import { LiveButton } from "../LiveButton";
import { SoundButton } from "@/components/buttons/SoundButton";
import { MoreButton } from "../MoreButton";
import { LikeButton } from "../LikeButton";
import { IGif } from "@/common/services/types";
import { FSButton } from "@/components/buttons/FSButton";
import { useDeviceType } from "@/common/hooks";
import { deviceTypeEnum } from "@/common/utils/device";
import { ViewButton, ViewButtonType } from "@/components/buttons/ViewButton";
import { useNavigate } from "react-router-dom";
import { routes } from "@/common/utils/routes";
import { useMediaQuery } from "usehooks-ts";
import "./Sidebar.scss";

interface ISidebarProps {
  gif: IGif;
  liked: boolean;
  likesCount: number;
  gifSound: boolean;
  isLite: boolean;
  rel?: string;
  onMenu: (event: React.MouseEvent<HTMLButtonElement>, gif: IGif) => void;
  onLike: () => void;
  onSound: (sound: boolean) => void;
}

export const Sidebar: React.FC<ISidebarProps> = memo((props) => {
  const {
    gif,
    likesCount,
    liked,
    gifSound,
    isLite,
    rel,
    onLike,
    onSound,
    onMenu
  } = props;

  const navigate = useNavigate();
  const isLand = useMediaQuery("(max-width: 1024px) and (orientation: landscape)");
  const isMobile = (useDeviceType() === deviceTypeEnum.PHONE) || isLand;
  const hasCta = useMemo(() => gif.cta && gif.cta.text && gif.cta.link, [gif.cta]);

  return (
    <ul className={`sideBar ${isLite ? "isLite" : ""} ${hasCta ? "isBoosted" : ""}`}>
      <li className="sideBarItem">
        <ViewButton
          type={ViewButtonType.IMAGE}
          count={gif.views}
          onClick={() => navigate(routes.watch(gif.id, rel))}
        />
      </li>

      {!isMobile && (
        <li className="sideBarItem">
          <FSButton gifId={gif.id} />
        </li>
      )}

      {gif.hasAudio && (
        <li className="sideBarItem">
          <SoundButton
            enabled={gifSound}
            onClick={() => onSound(!gifSound)}
          />
        </li>
      )}

      <li className="sideBarItem">
        <LikeButton
          id={gif.id}
          liked={liked}
          count={likesCount}
          onClick={onLike}
        />
      </li>

      <li className="sideBarItem">
        <MoreButton onClick={(e) => onMenu(e, gif)} />
      </li>

      {!isLite && !hasCta && (
        <li className="sideBarItem">
          <LiveButton />
        </li>
      )}
    </ul>
  );
});
